import React, { useState } from "react";
import logo from "../../../assets/Aara_logo.png";
import PhoneInput from "react-phone-input-2";

const OthersForm = ({
  formData,
  setFormData,
  handleSubmit,
  isSubmitted,
}) => {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [planningAbroad, setPlanningAbroad] = useState(false);

  React.useEffect(() => {
    if (formData.study_abroad !== undefined && formData.study_abroad !== null) {
      if (formData.study_abroad !== "No") {
        setPlanningAbroad(true);
      } else {
        setPlanningAbroad(false);
      }
    }
  }, [formData.study_abroad]);

  const handleRadioChange = (isYes) => {
    setPlanningAbroad(isYes);
    if (!isYes) {
      setFormData((prev) => ({ ...prev, study_abroad: "No" }));
    } else {
      setFormData((prev) => ({ ...prev, study_abroad: "" }));
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Valid email is required";
    }
    if (!formData.phone) newErrors.phone = "Mobile number is required";
    if (!formData.session_type) newErrors.session_type = "Session type is required";
    if (!formData.current_qualification) {
      newErrors.current_qualification = "Current qualification is required";
    }
    if (!formData.place_of_residence) {
      newErrors.place_of_residence = "Place of residence is required";
    }
    if (!formData.school_college_name) {
      newErrors.school_college_name = "School/College name is required";
    }
    if (!formData.gpa_percentage) {
      newErrors.gpa_percentage = "GPA/Percentage obtained is required";
    }
    if (!formData.expectations) {
      newErrors.expectations = "Expectations are required";
    }

    return newErrors;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setTouched(
        Object.keys(validationErrors).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        )
      );
    } else {
      setErrors({});
      handleSubmit(e);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  if (isSubmitted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <img
          src={logo}
          alt="Aara Consultancy Logo"
          className="h-16 sm:h-24 mb-6"
        />
        <h1 className="text-2xl sm:text-4xl font-bold text-gray-800 mb-4 text-center">
          Thank You for Submitting!
        </h1>
        <p className="text-base sm:text-lg text-gray-600 mb-6 text-center">
          We have received your information and will get back to you soon.
        </p>
      </div>
    );
  }

  return (
    <div className="container max-w-4xl mx-auto p-4">
      {/* Logo Section */}
      <div className="flex justify-center mb-6">
        <img src={logo} alt="Aara Consultancy Logo" className="h-16 sm:h-20" />
      </div>
      <form
        onSubmit={onSubmit}
        className="bg-gray-100 shadow-lg p-4 sm:p-6 rounded-lg"
      >
        <h2 className="text-xl sm:text-2xl font-semibold text-center mb-4">
          Student Information Form
        </h2>
        <p className="text-xs sm:text-sm text-gray-500 mb-4">
          Fields marked with * are mandatory and cannot be left blank!
        </p>

        <div className="grid grid-cols-1 gap-4">
          {/* Session Type */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="session_type"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Session Type *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="session_type"
                name="session_type"
                value={formData.session_type || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={Boolean(formData.session_type)}
                className={`border rounded-lg p-2 w-full ${
                  formData.session_type
                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                    : "bg-white text-gray-800"
                } ${
                  touched.session_type && errors.session_type ? "border-red-500" : ""
                }`}
              >
                <option value="">Select Session Type</option>
                <option value="College Selection">College Selection</option>
                <option value="Follow up">Follow up</option>
                <option value="School/Board Selection">School/Board Selection</option>
              </select>
              {touched.session_type && errors.session_type && (
                <div className="text-red-500 text-xs mt-1">{errors.session_type}</div>
              )}
            </div>
          </div>

          {/* Name */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="name"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Name *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.name && errors.name ? "border-red-500" : ""
                }`}
              />
              {touched.name && errors.name && (
                <div className="text-red-500 text-xs mt-1">{errors.name}</div>
              )}
            </div>
          </div>

          {/* Email */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="email"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Email *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.email && errors.email ? "border-red-500" : ""
                }`}
              />
              {touched.email && errors.email && (
                <div className="text-red-500 text-xs mt-1">{errors.email}</div>
              )}
            </div>
          </div>

          {/* Phone */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="phone"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Mobile No *
            </label>
            <div className="w-full sm:w-1/2">
              <PhoneInput
                country={"in"}
                value={formData.phone || ""}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, phone: value }))
                }
                onBlur={handleBlur}
                inputProps={{
                  name: "phone",
                  id: "phone",
                  className: touched.phone && errors.phone ? "border-red-500" : "",
                }}
                inputStyle={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "6px",
                  borderColor: touched.phone && errors.phone ? "#f56565" : "#ccc",
                  paddingLeft: "50px",
                }}
                dropdownStyle={{ width: "320px" }}
              />
              {touched.phone && errors.phone && (
                <div className="text-red-500 text-xs mt-1">{errors.phone}</div>
              )}
            </div>
          </div>

          {/* Current/Past Qualification */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="current_qualification"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Current/Past Qualification *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="current_qualification"
                name="current_qualification"
                value={formData.current_qualification || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.current_qualification && errors.current_qualification ? "border-red-500" : ""
                }`}
              />
              {touched.current_qualification && errors.current_qualification && (
                <div className="text-red-500 text-xs mt-1">{errors.current_qualification}</div>
              )}
            </div>
          </div>

          {/* Place of Residence */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="place_of_residence"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Place of Residence *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="place_of_residence"
                name="place_of_residence"
                value={formData.place_of_residence || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.place_of_residence && errors.place_of_residence ? "border-red-500" : ""
                }`}
              />
              {touched.place_of_residence && errors.place_of_residence && (
                <div className="text-red-500 text-xs mt-1">{errors.place_of_residence}</div>
              )}
            </div>
          </div>

          {/* School/College Name */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="school_college_name"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              School/College Name *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="school_college_name"
                name="school_college_name"
                value={formData.school_college_name || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.school_college_name && errors.school_college_name ? "border-red-500" : ""
                }`}
              />
              {touched.school_college_name && errors.school_college_name && (
                <div className="text-red-500 text-xs mt-1">{errors.school_college_name}</div>
              )}
            </div>
          </div>

          {/* GPA/Percentage Obtained */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="gpa_percentage"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              GPA/Percentage obtained *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="gpa_percentage"
                name="gpa_percentage"
                value={formData.gpa_percentage || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.gpa_percentage && errors.gpa_percentage ? "border-red-500" : ""
                }`}
              />
              {touched.gpa_percentage && errors.gpa_percentage && (
                <div className="text-red-500 text-xs mt-1">{errors.gpa_percentage}</div>
              )}
            </div>
          </div>

          {/* Study Abroad Planning */}
          <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center">
            <label className="font-semibold mb-1 sm:mb-0 sm:w-1/2">
              Are you planning to study abroad?
            </label>
            <div className="w-full sm:w-1/2 flex flex-col">
              <div className="flex gap-4 mt-1">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="study_abroad_radio"
                    checked={planningAbroad}
                    onChange={() => handleRadioChange(true)}
                    className="border-gray-300 text-purple-600 focus:ring-purple-500 h-4 w-4"
                  />
                  <span className="ml-2 text-sm text-gray-700">Yes</span>
                </label>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="study_abroad_radio"
                    checked={!planningAbroad}
                    onChange={() => handleRadioChange(false)}
                    className="border-gray-300 text-purple-600 focus:ring-purple-500 h-4 w-4"
                  />
                  <span className="ml-2 text-sm text-gray-700">No</span>
                </label>
              </div>

              {planningAbroad && (
                <input
                  type="text"
                  id="study_abroad"
                  name="study_abroad"
                  value={formData.study_abroad === "No" ? "" : formData.study_abroad || ""}
                  onChange={handleChange}
                  className="border rounded-lg p-2 w-full mt-2"
                  placeholder="Which country?"
                />
              )}
            </div>
          </div>

          {/* Work Experience */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="work_experience"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Mention about work experience if any
            </label>
            <div className="w-full sm:w-1/2">
              <textarea
                id="work_experience"
                name="work_experience"
                value={formData.work_experience || ""}
                onChange={handleChange}
                rows={3}
                className="border rounded-lg p-2 w-full"
              />
            </div>
          </div>

          {/* Extra Curriculars, Internships, etc */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="extra_information"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Any other information (Extra curriculars, Internships, Interests, Hobbies)
            </label>
            <div className="w-full sm:w-1/2">
              <textarea
                id="extra_information"
                name="extra_information"
                value={formData.extra_information || ""}
                onChange={handleChange}
                rows={3}
                className="border rounded-lg p-2 w-full"
              />
            </div>
          </div>

          {/* Expectations */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="expectations"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Please mention about the expectations from the counseling session *
            </label>
            <div className="w-full sm:w-1/2">
              <textarea
                id="expectations"
                name="expectations"
                value={formData.expectations || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                rows={3}
                className={`border rounded-lg p-2 w-full ${
                  touched.expectations && errors.expectations ? "border-red-500" : ""
                }`}
              />
              {touched.expectations && errors.expectations && (
                <div className="text-red-500 text-xs mt-1">{errors.expectations}</div>
              )}
            </div>
          </div>


          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="bg-red-500 hover:bg-red-600 transition-colors text-white py-2 px-6 rounded-lg font-medium"
              disabled={formData.isSubmitting}
            >
              {formData.isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default OthersForm;
